import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment";

import {
  renderTrendTable,
  Error,
  selectFormat,
  MAIN_COLORS,
} from "components/Utils/Utils.js";

class WorldCupMatchesEstimates extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  headerFormatter(column, colIndex, index) {
    const columnsToHide = [7, 8, 10, 11, 13, 14, 16, 17, 19, 20];
    const hideColumns = !columnsToHide.includes(colIndex);

    return (
      <div
        style={{
          backgroundColor: MAIN_COLORS[index],
          color: "#fff",
          padding: "5px",
        }}
      >
        {hideColumns && (
          <div
            style={{
              fontSize: "13px",
              textTransform: "uppercase",
              fontFamily: "Museo Slab W01",
              fontWeight: "bold",
            }}
          >
            {column.dataField.split(".")[0].split("_").join(" ")}
          </div>
        )}
        {column.text}
      </div>
    );
  }

  renderTable = (data) => {
    const { title } = this.props;

    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "match",
        text: "Match",
        style: {
          width: "150px",
          minWidth: "150px",
          textAlign: "left",
          fontWeight: "bold",
        },
        headerAlign: "left",
      },
      {
        dataField: "date",
        text: "Date",
        style: { width: "80px", minWidth: "80px" },
        csvFormatter: (_, row) => row && moment(row.date).format("YYYY-MM-DD"),
        headerAlign: "left",
        csvExport: true,
        formatter: (_, row) => {
          return moment(row.date).format("YYYY-MM-DD");
        },
      },
      {
        dataField: "start_time",
        text: "Start Time",
        style: { width: "80px", minWidth: "80px" },
        headerAlign: "left",
      },
      {
        dataField: "network",
        text: "Network",
        style: { width: "60px", minWidth: "60px" },
        headerAlign: "left",
      },
      {
        dataField: "stage",
        text: "Stage",
        style: { width: "80px", minWidth: "80px" },
        headerAlign: "left",
      },
      {
        dataField: "game_number",
        text: "Game #",
        align: "center",
        style: { width: "60px", minWidth: "60px" },
        headerAlign: "center",
      },
      {
        dataField: "linear_p2.actuals",
        text: "Actual",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 0),
      },
      {
        dataField: "linear_p2.estimates",
        text: "Estimates",
        align: "center",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 0),
      },
      {
        dataField: "linear_p2.difference_percentages",
        text: "% Difference",
        headerAlign: "left",
        align: "center",
        style: {
          width: "100px",
          minWidth: "100px",
          backgroundColor: "#f2f2f2",
        },
        formatter: renderTrendTable,
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 0),
      },

      {
        dataField: "total_minutes.actuals",
        text: "Actual",
        style: {
          width: "100px",
          minWidth: "100px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 1),
      },
      {
        dataField: "total_minutes.estimates",
        text: "Estimates",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 1),
      },
      {
        dataField: "total_minutes.difference_percentages",
        text: "% Difference",
        headerAlign: "left",
        align: "center",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        formatter: renderTrendTable,
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 1),
      },

      {
        dataField: "peacock_minutes.actuals",
        text: "Actual",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 2),
      },
      {
        dataField: "peacock_minutes.estimates",
        text: "Estimates",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 2),
      },
      {
        dataField: "peacock_minutes.difference_percentages",
        text: "% Difference",
        headerAlign: "left",
        align: "center",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        formatter: renderTrendTable,
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 2),
      },

      {
        dataField: "deportes_minutes.actuals",
        text: "Actual",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 3),
      },
      {
        dataField: "deportes_minutes.estimates",
        text: "Estimates",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 3),
      },
      {
        dataField: "deportes_minutes.difference_percentages",
        text: "% Differences",
        headerAlign: "left",
        align: "center",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        formatter: renderTrendTable,
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 3),
      },

      {
        dataField: "one_app_minutes.actuals",
        text: "Actual",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 4),
      },
      {
        dataField: "one_app_minutes.estimates",
        text: "Estimates",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        formatter: (cell) => selectFormat("number", cell && cell, "0,0"),
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 4),
      },
      {
        dataField: "one_app_minutes.difference_percentages",
        text: "% Differences",
        headerAlign: "left",
        align: "center",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        formatter: renderTrendTable,
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 4),
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            wrapperClasses="world-cup-sticky-table-header"
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const data = this.props.data.data;

    if (data.hasData === false) {
      return <Error minHeight={560} />;
    }

    return (
      <>
        <div className="col-12">
          <small className="info-format">
            All values are in Thousands (000)
          </small>
        </div>
        <div className="world-cup-actual-estimates-table">
          {this.renderTable(data)}
        </div>
      </>
    );
  }
}

export default WorldCupMatchesEstimates;
